import { createTheme, ThemeOptions } from "@mui/material/styles";
import theme from "../../../../../../../common/styles/appTheme";

const typographyThemeConfig = {
  ...theme,
  components: {
    MuiTypography: {
      styleOverrides: {
        body1: {
          textAlign: "center",
          marginBottom: "0"
        }
      }
    }
  }
};

export const muiTypographyTheme = createTheme(typographyThemeConfig as ThemeOptions);
